import * as React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import BookIcon from '@mui/icons-material/Book';
import GoogleIcon from '@mui/icons-material/Google';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  useDelete,
  useGetOne,
  useNotify,
  useRefresh,
} from 'react-admin';
import {
  Tooltip,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@mui/material';

export const CourseCityDateItem = ({
  ccd,
  canDelete = false,
  canEdit = false,
  canEditPublished = false,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [deleteOne, { isPending: isDeleting }] = useDelete();
  const { data, isLoading, error } = useGetOne('course_city_dates', {
    id: ccd,
  });

  if (isLoading) {
    return null;
  }

  if (error) {
    console.error(error);
  }

  const renderIcons = () => {
    return (
      <>
        {data.drupalId !== null && (
          <Tooltip title="Is Live">
            <CheckIcon fontSize={'small'} color={'success'} />
          </Tooltip>
        )}
        {data.drupalId === null && (
          <Tooltip title="Is Not Live">
            <CloseIcon fontSize={'small'} color={'error'} />
          </Tooltip>
        )}
        {data.onDemand && (
          <Tooltip title="Auf Anfrage">
            <NotListedLocationIcon fontSize={'small'} color={'info'} />
          </Tooltip>
        )}
        {!data.onDemand && (
          <Tooltip title="Buchung">
            <BookIcon fontSize={'small'} color={'info'} />
          </Tooltip>
        )}
        {data.guaranteedDate && (
          <Tooltip title="Guaranteed Date">
            <GoogleIcon fontSize={'small'} color={'success'} />
          </Tooltip>
        )}
      </>
    );
  };

  const handleDelete = () => {
    if (!window.confirm(`Delete date ${data.dateView}?`)) {
      return;
    }

    deleteOne(
      'course_city_dates',
      { id: data['@id'], previousData: data },
      {
        onSuccess: () => {
          notify('Date deleted', { type: 'success' });
          refresh();
        },
        onError: (deleteError) => {
          notify(deleteError.message || 'Could not delete date', {
            type: 'error',
          });
        },
      }
    );
  };

  return (
    <ListItem key={data['@id']} sx={{ pl: 4 }} dense>
      <ListItemIcon>
        <CalendarMonthIcon />
      </ListItemIcon>
      <ListItemText>
        {data.dateView} {renderIcons()}
      </ListItemText>
      {canEdit && (canEditPublished || data.drupalId === null) && (
        <IconButton
          href={`/#/course_city_dates/${encodeURIComponent(data['@id'])}`}
          edge="end"
          aria-label="edit date"
        >
          <EditIcon />
        </IconButton>
      )}
      {canDelete && (
        <IconButton
          onClick={handleDelete}
          edge="end"
          aria-label="delete date"
          disabled={isDeleting}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </ListItem>
  );
};
